export enum SortBy {
    FIRST_NAME_LAST_NAME = 'FIRST_NAME_LAST_NAME',
    LAST_NAME_FIRST_NAME = 'LAST_NAME_FIRST_NAME',
    RESERVATION_NUMBER = 'RESERVATION_NUMBER',
    PHONE = 'PHONE',
}
